import apiClient, { optionalParams } from "@/services/apiClient";

/**
 * @typedef {Object} Incident
 * @property {number} id
 * @property {string} subject
 * @property {string} status
 * @property {string} created_at
 * @property {string} [cf_sold_solution]
 * @property {string} [cf_short_title]
 * @property {string} [cf_severity_level_picklist]
 */

/**
 * @typedef {Object} IncidentListResponse
 * @property {Incident[]} data
 * @property {number} count
 */

const TICKET_TYPE = "Incident";
const FILTER_BY = "subject,cf_sold_solution,cf_short_title";

export const IncidentService = {
  /**
   * Recupera la lista degli incident con paginazione e ricerca opzionale.
   *
   * @param {Object} [params]
   * @param {string}  [params.search_by]    - Stringa di ricerca libera (min 3 caratteri lato chiamante)
   * @param {number}  [params.page=0]       - Numero pagina corrente (0-based)
   * @param {number}  [params.page_size=10] - Elementi per pagina
   * @returns {Promise<{ data: IncidentListResponse|null, error: string|null }>}
   */
  async getList({ search_by, page = 0, page_size = 10 } = {}) {
    try {
      const body = {
        page_size,
        service: TICKET_TYPE,
        page,
        ...optionalParams({
          search_by,
          filter_by: search_by ? FILTER_BY : undefined,
        }),
      };

      const { data } = await apiClient.post("tickets/v1/ticket-list", body);
      return { data, error: null };
    } catch (e) {
      if (
        e.response?.status === 404 ||
        e.response?.status === 403
      ) {
        return { data: { data: [], count: 0 }, error: null };
      }
      return { data: null, error: e.userMessage ?? e.message };
    }
  },
};
